import { render, staticRenderFns } from "./CareReserve.vue?vue&type=template&id=5a7bd5bc&scoped=true&"
import script from "./CareReserve.vue?vue&type=script&lang=js&"
export * from "./CareReserve.vue?vue&type=script&lang=js&"
import style0 from "./CareReserve.vue?vue&type=style&index=0&id=5a7bd5bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7bd5bc",
  null
  
)

export default component.exports